var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7796 29.619V22.7142H23.2143V29.619C23.2143 30.3786 23.8258 31 24.573 31H28.6491C29.3964 31 30.0078 30.3786 30.0078 29.619V19.9523H32.3175C32.9425 19.9523 33.2414 19.1651 32.7659 18.7508L21.4073 8.35215C20.891 7.88262 20.103 7.88262 19.5867 8.35215L8.22806 18.7508C7.76611 19.1651 8.05143 19.9523 8.67642 19.9523H10.9862V29.619C10.9862 30.3786 11.5976 31 12.3449 31H16.4209C17.1682 31 17.7796 30.3786 17.7796 29.619Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/Icon_home.11a9c73e3c621cdc2334b9bd63f8e050.svg";
export { ForwardRef as ReactComponent };